import { donations } from "./donations";
import { admin } from "./admin";
import { cms } from "./cms";

export const mockApi = {
  ...donations,
  ...admin,
  ...cms,
};
